import React from 'react';

import Skeleton from '@atlaskit/avatar/skeleton';
import { fg } from '@atlassian/jira-feature-gating';
import { useIssueTypeAvatarUrl, useIssueTypeName } from './useIssueTypeName.tsx';
import { IssueTypeAvatar, type IssueTypeAvatarSizes } from './IssueTypeAvatar.tsx';

type IssueTypeId = string;

type Props = {
	issueTypeId: IssueTypeId;
	size?: IssueTypeAvatarSizes;
	iconlLabel?: string;
};

export const IssueTypeIcon = ({
	issueTypeId,
	iconlLabel,
	size = 'xsmall',
}: Props): React.JSX.Element => {
	const avatarUrl = useIssueTypeAvatarUrl({ issueTypeId });
	const issueTypeName = useIssueTypeName({ issueTypeId });
	const iconName =
		iconlLabel !== undefined && fg('jpd_a11y_decorative_icons') ? iconlLabel : issueTypeName;
	const skeletonSize = size === 'xsmall' ? 'xxsmall' : size;

	if (avatarUrl === undefined) {
		return <Skeleton appearance="square" size={skeletonSize} />;
	}

	return <IssueTypeAvatar avatarUrl={avatarUrl} size={size} name={iconName} />;
};
